import { Component, Input } from '@angular/core';
import { SettlementPeriod } from '@models/insurance-type';
import { DisplayPriceComponent } from 'app/shared/components/display-price/display-price.component';

@Component({
    selector: 'app-price-display-card',
    templateUrl: './price-display-card.component.html',
    styleUrl: './price-display-card.component.scss',
    host: {
        'class.-obscured': '!this.price',
    },
    imports: [DisplayPriceComponent],
})
export class PriceDisplayCardComponent {
    @Input()
    public price: number;
    @Input()
    public settlementPeriod: SettlementPeriod;
    @Input()
    public taxInfo: string;
    @Input()
    public buttonText?: string;
    @Input()
    public buttonDisabled = false;
    @Input()
    public bannerText?: string;
}
